import type { OfflineDraftRecord } from "../../types/requisition";
import { deleteOfflineRecord, getOfflineRecord, listOfflineRecords, upsertOfflineRecord } from "./schema";
import { normalizeOfflineStoreKey, normalizeUuid } from "./uuidCompatibility";

export async function saveDraft(draft: OfflineDraftRecord): Promise<void> {
  await upsertOfflineRecord("requisitionDrafts", draft.localDraftId, draft);
}

export async function getDraft(localDraftId: string): Promise<OfflineDraftRecord | undefined> {
  return getOfflineRecord<OfflineDraftRecord>("requisitionDrafts", localDraftId);
}

export async function listDrafts(): Promise<OfflineDraftRecord[]> {
  const drafts = await listOfflineRecords<OfflineDraftRecord>("requisitionDrafts");
  return drafts.sort((left, right) => left.updatedAt.localeCompare(right.updatedAt));
}

export async function deleteDraft(localDraftId: string): Promise<void> {
  await deleteOfflineRecord("requisitionDrafts", localDraftId);
}

export async function findDraftByReference(referenceId: string): Promise<OfflineDraftRecord | undefined> {
  const drafts = await listDrafts();
  const normalizedReferenceId = normalizeUuid(referenceId);
  return drafts.find(
    (draft) =>
      normalizeOfflineStoreKey(draft.localDraftId) === normalizeOfflineStoreKey(referenceId) ||
      (draft.serverRequisitionId !== null && normalizeUuid(draft.serverRequisitionId) === normalizedReferenceId),
  );
}
